import React from 'react';
import { Link } from 'react-router-dom';
import {
    cartItemTypeIdsThatCanBeDirectlyAddedToCart,
    cartItemTypeIdsWithoutProductDetailsPage,
} from '../../../models/constants';
import { IOrderDetails } from '../../../models/product-detail';
import AddToCart from '../../common/add-to-cart';

interface IWishListItemElementProps {
    title: string;
    subTitle: string;
    imageUrl: string;
    imageAltText: string;
    callToActionUrl: string;
    productId: string;
    cartItemTypeId: number;
    partNumber: string;
    maxQuantity: number;
    handleOnNavigate: () => void;
    addToCart: (order: IOrderDetails) => Promise<boolean>;
    selectedAgreement: string;
    country: string;
}

const WishListItemElement = ({
    title,
    subTitle,
    imageUrl,
    imageAltText,
    callToActionUrl,
    productId,
    cartItemTypeId,
    partNumber,
    maxQuantity,
    handleOnNavigate,
    addToCart,
    selectedAgreement,
    country,
}: IWishListItemElementProps) => {
    return (
        <div className="wish-list-item">
            <div>
                {cartItemTypeIdsWithoutProductDetailsPage.includes(
                    cartItemTypeId
                ) ? (
                    <img
                        src={imageUrl}
                        alt={imageAltText}
                        style={{
                            width: '200px',
                            height: '200px',
                            display: 'block',
                            margin: 'auto',
                            paddingTop: '5px',
                        }}
                    />
                ) : (
                    <Link to={callToActionUrl} onClick={handleOnNavigate}>
                        <img
                            src={imageUrl}
                            alt={imageAltText}
                            style={{
                                width: '200px',
                                height: '200px',
                                display: 'block',
                                margin: 'auto',
                                paddingTop: '5px',
                            }}
                        />
                    </Link>
                )}
            </div>
            <div
                style={{ borderTop: '2px dotted #c0c0c0', margin: '10px 15px' }}
            />
            <div className="row">
                {cartItemTypeIdsWithoutProductDetailsPage.includes(
                    cartItemTypeId
                ) ? (
                    <div className="col-md-12">
                        <h3 style={{ fontSize: '18px', textTransform: 'none' }}>
                            {title}
                        </h3>
                    </div>
                ) : (
                    <Link
                        to={callToActionUrl}
                        style={{ textAlign: 'left', paddingLeft: '0px' }}
                        onClick={handleOnNavigate}
                    >
                        <div className="col-md-12">
                            <h3
                                style={{
                                    fontSize: '18px',
                                    textTransform: 'none',
                                }}
                            >
                                {title}
                            </h3>
                        </div>
                    </Link>
                )}
            </div>
            {subTitle && (
                <div className="row">
                    <div className="col-md-12">
                        <h4>{subTitle}</h4>
                    </div>
                </div>
            )}
            {cartItemTypeIdsThatCanBeDirectlyAddedToCart.includes(
                cartItemTypeId
            ) && (
                <div
                    style={{
                        margin: '0px 15px 15px 15px',
                    }}
                >
                    <AddToCart
                        productId={productId}
                        cartItemTypeId={cartItemTypeId}
                        partNumber={partNumber}
                        maxQuantity={maxQuantity}
                        productUrl={''}
                        addToCart={addToCart}
                        selectedAgreement={selectedAgreement}
                        country={country}
                    />
                </div>
            )}
        </div>
    );
};

export default WishListItemElement;
